import { extend } from "vee-validate";
import {
  email,
  max,
  required,
  integer,
  double,
  alpha_dash as alphaDash,
  regex
} from "vee-validate/dist/rules";
import moment from "moment";
import VueI18n from "vue-i18n";
import { CheckBoxItemValue, RadioItemValue } from "@/models/SurveyItem";

export const setupValidation = function(i18n: VueI18n) {
  extend("required", {
    ...required,
    message: (_, values) => i18n.t("validations.required", values).toString()
  });
  extend("max", {
    ...max,
    message: (_, values) => i18n.t("validations.max", values).toString()
  });
  extend("email", {
    ...email,
    message: (_, values) => i18n.t("validations.email", values).toString()
  });
  extend("alphaDash", {
    ...alphaDash,
    message: (_, values) => i18n.t("validations.alphaDash", values).toString()
  });
  extend("dateFormat", {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    validate: (value, { format }: Record<string, any>) => {
      return moment(value, format, true).isValid();
    },
    params: ["format"],
    message: (_, values) => i18n.t("validations.dateFormat", values).toString()
  });
  extend("radioOptionTextArea", {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    validate: (_, { value }: Record<string, any>) => {
      let ret = true;
      const parsed = JSON.parse(value) as RadioItemValue;
      if (parsed.optionTextArea !== undefined && !parsed.optionTextArea.text) {
        ret = false;
      }
      return ret;
    },
    params: ["value"],
    message: (_, values) =>
      i18n.t("validations.optionTextArea", values).toString()
  });
  extend("checkBoxOptionTextArea", {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    validate: (_, { value }: Record<string, any>) => {
      let ret = true;
      const parsed = JSON.parse(value) as CheckBoxItemValue;
      parsed.optionTextArea?.forEach(v => {
        if (!v.text) {
          ret = false;
        }
      });
      return ret;
    },
    params: ["value"],
    message: (_, values) =>
      i18n.t("validations.optionTextArea", values).toString()
  });
  extend("double", {
    validate: (value, { ids }: Record<string, any>) => {
      if (Object.values(ids).filter(id => id === value).length > 1) {
        return false;
      }
      return true;
    },
    params: ["ids"],
    message: (_, values) => i18n.t("validations.double", values).toString()
  });
  extend("integer", {
    ...integer,
    message: (_, values) => i18n.t("validations.integer", values).toString()
  });
  extend("decimal", {
    ...double,
    message: (_, values) => i18n.t("validations.decimal", values).toString()
  });
  extend("regex", {
    ...regex,
    message: (_, values) =>
      i18n.t("validations.integerordecimal", values).toString()
  });
};
